var _excluded = ["classes", "className", "disabled", "hint", "id", "name", "children", "required", "messages"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import FieldLabel from '../internal/field/field-label';
import FieldHint from '../internal/field/field-hint';
require("./checkbox.css");
var styles = {
  "icon": "icon-3F--7",
  "checkbox": "checkbox-4q1ME",
  "label": "label-3ttZn",
  "labelWrapper": "labelWrapper-1a9Oe"
};
var Checkbox = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      classes,
      className,
      disabled,
      hint,
      id,
      name,
      children,
      required,
      messages
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var labelId = "".concat(id, "-label");
  var hintId = "".concat(id, "-hint");
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: cs(styles.checkbox, 'lll-hidden-visually'),
    "aria-labelledby": labelId,
    id: id,
    disabled: disabled,
    "aria-describedby": hint ? hintId : null,
    required: required,
    ref: ref,
    type: "checkbox"
  }, otherProps)), /*#__PURE__*/React.createElement(FieldLabel, {
    className: cs(styles.label, classes.label),
    htmlFor: id,
    id: labelId,
    required: required,
    optionalMessage: messages && messages.optional
  }, /*#__PURE__*/React.createElement("span", {
    className: cs(styles.icon, classes.icon)
  }), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.labelWrapper, classes.labelContent)
  }, children)), hint && /*#__PURE__*/React.createElement(FieldHint, {
    id: hintId
  }, hint));
});
Checkbox.propTypes = {
  classes: PropTypes.shape({
    icon: PropTypes.string,
    label: PropTypes.string,
    labelContent: PropTypes.string
  }),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /** Hint text for validation messages */
  hint: PropTypes.node,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  /** The field's label */
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  /** Localized strings */
  messages: PropTypes.shape({
    optional: PropTypes.string
  })
};
Checkbox.defaultProps = {
  classes: {},
  className: null,
  disabled: false,
  hint: null,
  name: null,
  required: true,
  messages: {}
};
export default Checkbox;